
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class ProjectBudgetSheet extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({ default: () => [] })
    activeProjectConversionFactor!: number;
    @Prop({ default: () => [] })
    disabled!: boolean;
    @Prop({ default: () => [] })
    projectYear!: number;
    
    forceReload = 0;

    updateLineSum(itemId: any, projectId: any, proposedBudget: number, approvedBudget: number, realignedBudget: number, budgetTemplateId: number, lineSplit: any, lineItem: any, sectionName: any) {
      this.$emit('lineValueChanged', {itemId, projectId, proposedBudget, approvedBudget, realignedBudget, budgetTemplateId, lineSplit, lineItem, sectionName})
    }

    proposedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.proposedBudget || 0), 0);
    }
    proposedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.proposedBudget * row.lineSplit) || 0), 0);
    }
    proposedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.proposedBudget * (1 - row.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    approvedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.approvedBudget || 0), 0);
    }
    approvedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.approvedBudget * row.lineSplit) || 0), 0);
    }
    approvedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.approvedBudget * (1 - row.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    reAllignedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.realignedBudget || 0), 0);
    }
    reAllignedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.realignedBudget * row.lineSplit) || 0), 0);
    }
    reAllignedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.realignedBudget * (1 - row.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    mounted() {
      this.forceReload += 1;
    }
}
